/* file description */
import React, { useState, useEffect } from 'react';
import { Popconfirm } from 'antd';
import { ERROR_MSG_MAP } from './console_msg/errorMsgs';
import type { EditableProp, UseEditableProp } from './type';

export const useEditableProp: UseEditableProp = ({
  editable,
  actionRef,
  request,
  autoRowEditConfig,
  getRowsData,
  rowsData,
  rowKey,
  tableDataEdit,
}) => {
  const [editableKeys, setEditableRowKeys] = useState<React.Key[]>([]);
  const tableData = rowsData || getRowsData?.();
  useEffect(() => {
    if (tableData) {
      setEditableRowKeys(tableData.map((item: any) => item[rowKey]));
    }
  }, [tableData, rowKey]);

  // 如果传了editable，以用户传的为第一优先级。
  if (editable !== undefined) {
    if (tableDataEdit) {
      editable.editableKeys = editableKeys;
      editable.onChange = setEditableRowKeys;
    }
    editable.type = 'multiple';
    return editable;
  }
  const editableAutoConfig: EditableProp = {
    type: 'multiple',
    actionRender: (_row, _config, defaultDom) => {
      let deleteRecord = defaultDom.delete;
      if (_row?.RECORD?.createdAt) {
        deleteRecord = (
          <Popconfirm
            key="delete"
            title="确认要删除这一项吗?"
            onConfirm={async () => {
              // await autoRowEditConfig!.onDelete!(_row.RECORD.recordID, _row);
              await autoRowEditConfig!.onDelete!(_row?._id, _row);
              actionRef!.current?.reload();
            }}
            okText="确认"
            cancelText="取消"
          >
            <a href="#">删除</a>
          </Popconfirm>
        );
      }
      return autoRowEditConfig?.hideSave ? [deleteRecord] : [defaultDom.save, defaultDom.cancel];
    },
  };
  if (tableDataEdit) {
    editableAutoConfig.editableKeys = editableKeys;
    editableAutoConfig.onChange = setEditableRowKeys;
  }
  if (autoRowEditConfig?.hideSave) {
    return editableAutoConfig;
  }
  if (autoRowEditConfig) {
    if (!request) {
      // console.error(ERROR_MSG_MAP.autoLineEditConfigWithOutRequest);
      return editable;
    }
    const { onSave } = autoRowEditConfig;
    // 开启自动化编辑保存并且reload的能力
    if (actionRef) {
      // request和actionRef配置了的话，编辑保存后, 可以自动reload，回显table数据。
      if (onSave) {
        editableAutoConfig.onSave = async (...params) => {
          try {
            await onSave(...params);
          } catch (error) {
            console.error(ERROR_MSG_MAP.autoLineEditOnSaveRunError);
            throw error;
          }
          const res = await actionRef.current?.reload();
          return res;
        };
      }
    }
    return editableAutoConfig;
  }
};
